// 是否展示“禁止挂网”标签（热销推荐 / index/to_you）
export function showForbidNet(tags) {
  if (!tags) return false;
  if (Array.isArray(tags)) {
    return tags.indexOf('禁止挂网') !== -1;
  }
  return (tags + '').indexOf('禁止挂网') !== -1;
}



// WEBPACK FOOTER //
// ./src/utils/goods.js